import FormCollapse from "../../common/FormCollapse";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
// import {
//   locationOptions,
//   ProviderCategories,
//   ProviderSubCategories,
//   ProviderVerified,
//   ProviderRatings,
// } from "../../../data/ecommerce/filterOptions";
import CheckboxItem from "../../common/CheckboxItem";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useMemo } from "react";
import { useTagsStore } from "../../../store/tagsStore";
// this is child component of ProvidersFilter.tsx

const initialFilters = {
  // for clearing all applied filters
  location: [],
  category: [],
  subCategory: [],
  verified: null,
  rating: null,
};

interface ProductFilterItemsProps {
  handleClose: () => void;
  tempFilters: {
    location: string[];
    category: string[];
    // subCategory: string[];
    verified: string | null;
    rating: string | null;
  };
  setTempFilters: any;
  onApply: () => void;
}

const ProductFilterItems: React.FC<ProductFilterItemsProps> = ({
  handleClose,
  tempFilters,
  setTempFilters,
  onApply,
}) => {
  useEffect(() => {
    // causing stutter in the UI when i click a category from home page
    onApply(); // Apply the filter only after state updates
  }, [tempFilters]); // Runs every time tempFilters changes
  const providerLocation = useTagsStore((state) => state.providerLocation);
  const providerCategories = useTagsStore((state) => state.providerCategories);
  const providerVerifiedUser = useTagsStore(
    (state) => state.providerVerifiedUser
  );
  const providerTopUser = useTagsStore((state) => state.providerTopUser);

  const locationOptions = useMemo(() => {
    return [...providerLocation]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((location) => ({
        name: "location",
        value: location.id,
        label: location.name,
      }));
  }, []);

  const providerCategoriesOptions = useMemo(() => {
    return [...providerCategories]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((category) => ({
        name: "category",
        value: category.id,
        label: category.name,
      }));
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Filtros</h3>
        <button className="btn p-0 d-lg-none" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} size="sm" />
        </button>
      </div>
      <div className="p-2">
        {" "}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevents page jump
            setTempFilters(initialFilters);
          }}
          style={{
            cursor: "pointer",
            textDecoration: "none",
            fontSize: "14px",
            color: "black",
            fontWeight: "semi-bold",
          }}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            style={{ marginRight: "5px" }}
          />
          Limpiar filtros
        </a>{" "}
      </div>

      <FormCollapse title="Ubicación" defaultOpen={false}>
        Mexico
        <div className="ps-3">
          {locationOptions.map((item) => (
            <CheckboxItem
              name={item.name}
              value={item.label}
              label={item.label}
              key={item.value}
              checked={tempFilters.location.includes(String(item.label))}
              onChange={(e) => {
                const { checked, value } = e.target;
                setTempFilters((prevFilters: any) => {
                  const newLocation = checked
                    ? [...prevFilters.location, value]
                    : prevFilters.location.filter((v: any) => v !== value);
                  return { ...prevFilters, location: newLocation };
                });
              }}
            />
          ))}
        </div>
      </FormCollapse>
      {/* Categories Filter */}
      <FormCollapse title="Categorías">
        <div className="ps-3">
          {/* <CheckboxItem
            name={"category"}
            value={"all"}
            label={"Todas"}
            checked={tempFilters.category.includes("all")}
            onChange={(e) => {
              const { checked, value } = e.target;
              setTempFilters((prevFilters: any) => {
                const newCategory = checked
                  ? [...prevFilters.category, value]
                  : prevFilters.category.filter((v: any) => v !== value);
                return { ...prevFilters, category: newCategory };
              });
            }}
          /> */}
          {providerCategoriesOptions.map((item) => (
            <CheckboxItem
              name={item.name}
              value={item.label}
              label={item.label}
              key={item.value}
              checked={tempFilters.category.includes(String(item.label))}
              onChange={(e) => {
                const { checked, value } = e.target;
                setTempFilters((prevFilters: any) => {
                  const newCategory = checked
                    ? [...prevFilters.category, value]
                    : prevFilters.category.filter((v: any) => v !== value);
                  return { ...prevFilters, category: newCategory };
                });
              }}
            />
          ))}
        </div>
      </FormCollapse>

      {/* Sub-Categories Filter */}
      {/* <FormCollapse title="Sub-Categorías">
        <div className="ps-3">
          {ProviderSubCategories.map((item) => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
              checked={tempFilters.subCategory.includes(String(item.value))}
              onChange={(e) => {
                const { checked, value } = e.target;
                setTempFilters((prevFilters: any) => {
                  const newSubCategory = checked
                    ? [...prevFilters.subCategory, value]
                    : prevFilters.subCategory.filter((v: any) => v !== value);
                  return { ...prevFilters, subCategory: newSubCategory };
                });
              }}
            />
          ))}
        </div>
      </FormCollapse> */}

      {/* Verified Filter */}
      <FormCollapse title="Etiquetas">
        <div className="ps-3">
          {providerVerifiedUser && (
            <CheckboxItem
              name={"verified"}
              value={providerVerifiedUser.id.toString()}
              label={"Verificado"}
              checked={
                tempFilters.verified === providerVerifiedUser.id.toString()
              }
              onChange={(e) => {
                const { checked, value } = e.target;
                setTempFilters((prevFilters: any) => ({
                  ...prevFilters,
                  verified: checked ? value : null,
                }));
              }}
            />
          )}
          {providerTopUser && (
            <CheckboxItem
              name={"rating"}
              value={providerTopUser.id.toString()}
              label={"Proveedor Top"}
              checked={tempFilters.rating === providerTopUser.id.toString()}
              onChange={(e) => {
                const { checked, value } = e.target;
                setTempFilters((prevFilters: any) => ({
                  ...prevFilters,
                  rating: checked ? value : null,
                }));
              }}
            />
          )}
        </div>
      </FormCollapse>
      {/* <FormCollapse title="Calificación">
        <div className="ps-3">
          {ProviderRatings.map((item) => (
            <CheckboxItem
              name="rating"
              value={item.value}
              label={`${item.label} estrellas`}
              key={item.value}
              checked={tempFilters.rating.includes(Number(item.value))}
              onChange={(e) => {
                const { checked, value } = e.target;
                setTempFilters((prevFilters: any) => {
                  const newRatings = checked
                    ? [...prevFilters.rating, Number(value)]
                    : prevFilters.rating.filter(
                        (r: any) => r !== Number(value)
                      );
                  return { ...prevFilters, rating: newRatings };
                });
              }}
            />
          ))}
        </div>
      </FormCollapse> */}
      <div className="mt-4">
        {/* <Button
          variant="primary"
          onClick={() => {
            onApply()
            handleClose()
          }}
        >
          Apply
        </Button> */}
        {/* May be a good idea to add a clear filters button as well */}
      </div>
    </>
  );
};

export default ProductFilterItems;
